import type { CompleteRiotSignInData } from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { Attribution } from '@/shared/utils/attribution';
import { sleep } from '@/shared/utils/promise';

export interface CompleteRiotResponse {
  user: { id: string; username: string; displayName?: string | null };
}

const completeRiotSignInUrl: CompleteRiotSignInData['url'] = 'auth/riot/login';

export const completeRiotSignIn = (attribution?: Attribution | null) => {
  return PrivateApi.post(completeRiotSignInUrl, {
    json: attribution ?? undefined,
    timeout: 30_000,
    headers: {
      'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  }).json<CompleteRiotResponse>();
};

const MAX_RETRIES = 10;
const RETRY_DELAY_MS = 500;

/**
 * Retry completeRiotSignIn with delay.
 * Needed because Amplify processes ?code= asynchronously,
 * and tokens may not be available immediately on redirect.
 */
export const completeRiotSignInWithRetry = async (
  attribution?: Attribution | null,
) => {
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      return await completeRiotSignIn(attribution);
    } catch (error) {
      const isLastAttempt = attempt === MAX_RETRIES - 1;
      if (isLastAttempt) throw error;
      await sleep(RETRY_DELAY_MS);
    }
  }
};
